import { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
/**
 * Renders children into a DOM node outside the current component tree.
 * Used by overlay components (Modal, BottomSheet, SideDrawer) to ensure
 * correct z-index stacking regardless of where the component is mounted.
 *
 * Gracefully handles SSR — renders nothing on the server.
 */
export function Portal({ children, container }) {
    const [mounted, setMounted] = useState(false);
    const defaultContainerRef = useRef(null);
    useEffect(() => {
        if (!defaultContainerRef.current) {
            defaultContainerRef.current = document.createElement('div');
            defaultContainerRef.current.setAttribute('data-loci-portal', '');
            document.body.appendChild(defaultContainerRef.current);
        }
        setMounted(true);
        const el = defaultContainerRef.current;
        return () => {
            if (el && el.parentNode) {
                el.parentNode.removeChild(el);
            }
            defaultContainerRef.current = null;
        };
    }, []);
    if (!mounted)
        return null;
    const target = container ?? defaultContainerRef.current;
    if (!target)
        return null;
    return ReactDOM.createPortal(children, target);
}
